import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from '../../../environment';
import { TechnicalResult } from '../models/technical-result.model';

@Injectable({
  providedIn: 'root',
})
export class TechnicalResultService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/dairy-result/secure';

  public getByDate(start: string): Observable<TechnicalResult> {
    let end = new Date(start);
    end = new Date(Date.UTC(end.getFullYear(), end.getMonth() + 1, end.getDate(), 0, 0, 0));

    return this.http.get<TechnicalResult>(
      `${this.baseUrl}/technical-report?start=${start}&end=${end.toISOString()}`,
    );
  }
}
